<!-- 角色申请 -->
<template>
  <div class="workOrder">
    <div class="workOrder-wrap">
      <h1 class="personal-center-form__title">角色申请</h1>
      <div class="container">
        <div>
          <el-form :inline="true" class="demo-form-inline" @submit.native.prevent>
            <el-form-item v-if="!userInfo.isFinance || !userInfo.iscoreCompany || !userInfo.isThirdParty">
              <el-button type="primary" class="search-btn" @click="addRole(4)" v-if="!userInfo.isThirdParty">我要成为担保方</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="roleList" style="width: 100%">
            <el-table-column prop="roleType" label="申请角色" align="center" min-width="60"></el-table-column>
            <el-table-column prop="requestTime" label="申请时间" align="center" min-width="60" :formatter="formatDate">
            </el-table-column>
            <el-table-column prop="requestRemark" label="备注" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="审批状态" align="center" min-width="40">
              <template slot-scope="scope">{{stateMap[scope.row.status]}}</template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="40">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" size="mini" type="primary">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="block">
          <el-pagination
            v-if="roleList && roleList.length > 0"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="totalCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="角色申请" :visible.sync="dialogFormVisibleOrder">
      <el-form :model="addRoleInfo" :rules="rules" ref="addRoleInfo" class="work_order_add">
        <el-form-item label="邀请码：" :label-width="formLabelWidth">
          <el-input v-model="addRoleInfo.inviteCode" auto-complete="off" placeholder="请输入邀请码" width="100px"></el-input>
        </el-form-item>
        <el-form-item label="备注：" :label-width="formLabelWidth" class="el-order-height" prop="requestRemark">
          <el-input type="textarea" :rows="4" v-model="addRoleInfo.requestRemark" auto-complete="off" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleOrder = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('addRoleInfo')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "../../vuex/types/type";
import workApi from "../../api/personalCenter/work";
import moment from 'moment';

export default {
  data() {
    return {
      roleList: [],
      totalCount: 0,
      currentPage: 1,
      stateMap: {
        0: "待审批",
        1: "审批通过",
        2: "审批不通过",
        3: "审批中"
      },
      formSearch: {
        pageNum: 1,
        pageSize: 10,
      },
      dialogFormVisibleOrder: false,
      addRoleInfo: {
        roleType: "",
        inviteCode: "",
        requestRemark: "",
      },
      rules: {
        requestRemark: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("请输入备注"));
              } else if (value.length >= 140) {
                callback(new Error("备注内容最多输入140个字符！"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      formLabelWidth: "200px",
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.GET_USER
    })
  },
  methods: {
    ...mapActions({
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE,
    }),
    formatDate (row, column) {
      const date = row[column.property];
      if (date == undefined) {
        return '--';
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    handleClick(row) {
      this.$router.push({
        path: "/personalCenter/roleApplydetails",
        query: {
          roleRequestId: row.roleRequestId,
        },
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.formSearch.pageNum = val;
      this.fetchData();
    },
    fetchData() {
      workApi.getRoleRequestList({
        ...this.formSearch,
      }).then((res) => {
        const resData = res.data
        if (resData.code == 0) {
          this.roleList = resData.result.list;
          this.totalCount = parseFloat(resData.result.totalCount);
        } else {
          this.setFailMessage({
            show: true,
            content: resData.msg || "获取失败",
          });
        }
      })
    },

    // 添加角色申请
    addRole(roleType) {
      this.addRoleInfo.roleType = roleType
      this.dialogFormVisibleOrder = true
      this.addRoleInfo.inviteCode = ''
      if (this.$refs.addRoleInfo !== undefined) {
        this.$refs.addRoleInfo.resetFields()
      }
    },
    // 提交申请
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          workApi.roleRequestSubmit({
            ...this.addRoleInfo,
          }).then((res) => {
            if (res.code == 0) {
              this.dialogFormVisibleOrder = false
              this.setSuccessMessage({
                show: true,
                content: res.result || "申请成功",
              });
              this.fetchData();
            } else {
              this.setFailMessage({
                show: true,
                content: res.msg || "申请失败",
              });
            }
          })
        } else {
          return false;
        }
      });
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
<style lang="scss">
.workOrder {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: 15px;
  padding-left: 30px;
  .container {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    padding-top: 20px;
    padding-bottom: 75px;
    background-color: #fff;
  }
}
.work_order_add .el-input__inner,
.work_order_add .el-textarea__inner {
  width: 400px !important;
}
.work_order_add .el-form-item {
  height: initial !important;
}
.work_order_add .el-order-height {
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// roleApply.vue?063363f0